import superagent from 'superagent';

import apiStore from '../stores/api-store';

const FACETS_URL = '/facets';
const ITEMS_URL = '/items';
const TIMEOUT = 10000;

let state = apiStore.getInitialState();
let facetPreselectionCache = null;

apiStore.listen((newState) => {
	state = newState;
});

function getWithSelection(url, selectionName = 'preselection') {
	const selection = state[selectionName];
	const query = {
		selected: selection.selected.join(','),
		pinned: selection.selected.join(','),
		visible: selection.visible.join(',')
	};

	if (selection.itemList) {
		query.itemList = selection.itemList.join(',');
	}

	return get(url).query(query);
}

function get(url) {
	return superagent
		.get(state.apiUrl + url)
		.set('Accept', 'application/json')
		.timeout(TIMEOUT)
		.query({
			language: state.languageCode,
			showDisabled: state.showDisabled
		});
}

function createPromise(request, foo) {
	return new Promise((resolve, reject) => {
		request.end((error, response) => {
			if (error) {
				reject(error);
			} else {
				let data;
				if (typeof foo === 'undefined') {
					data = response.body;
				} else {
					data = response;
					data = Object.assign(foo, data);
				}
				resolve(data);
			}
		});
	});
}

// facets ----------------------------------------------------------
// get the facets from source
export function getFacets() {
	return createPromise(
		getWithSelection(FACETS_URL, 'preselection')
			.query({})
	);
}

export function getAccessoryFacets() {
	return createPromise(getWithSelection(FACETS_URL, 'accessoriesPreselection'));
}

// items ----------------------------------------------------------
// get the items from source
export function getItems(foo = false) {
	return createPromise(
		getWithSelection(ITEMS_URL)
			.query({
				itemsPerPage: 1000,
				itemsOffset: 0,
				noProps: false
			}),
		 foo
	);
}

// get the count of items from source
export function getItemCount(foo = false) {
	return createPromise(getWithSelection(ITEMS_URL).query({action: 'itemCount'}), foo);
}

export function getAccessories(foo = false) {
	return createPromise(
		getWithSelection(ITEMS_URL, 'accessories')
			.query({
				itemsPerPage: 100,
				itemsOffset: 0,
				//compositions: state.accessories.compositions.join(','),
				noProps: true
			}),
		 foo
	);
}

export function getAccessoryCount(foo = false) {
	return createPromise(getWithSelection(ITEMS_URL, 'accessories').query({action: 'itemCount'}), foo);
}

export function getAccessoryIdsForItems(foo = false) {
	return createPromise(
		get(ITEMS_URL)
			.query({
				selected: state.preselection.selected.join(','),
				pinned: state.preselection.selected.join(','),
				action: 'getAccessoireIds'
			}),
		 foo
	);
}
